/*
 *
 * Package: `@dbh/hotel-package-strip-theme`.
 *
 */const THEME_KEY_HOTEL_PACKAGE_STRIP="hotelPackageStrip";const modifyHotelPackageStripTheme=()=>({[THEME_KEY_HOTEL_PACKAGE_STRIP]:{closedHeight:"min-content"}});

export { THEME_KEY_HOTEL_PACKAGE_STRIP, modifyHotelPackageStripTheme as default };
